@if ((licenses$ | async)?.licenses; as licenses) {
  <div class="license-container">
    @if (licenses.length) {
      <div class="license-content">
        <table class="license-table">
          <thead>
            <tr >
              <th translate="license-management_license-name"></th>
              <th translate="license-management_start-date"></th>
              <th translate="license-management_end-date"></th>
              <th id="seats-used-column">
                <div class="license-seats">
                  {{'license-management_seat-used' | translate}}
                  <button
                    type="button"
                    class="icon-btn ficon-app-help-circle-outline seats-used-help"
                    [attr.aria-label]="'license-management_seat-used-help' | translate"
                    [goCdkPopover]="'license-management-seat-used-tooltip' | translate"
                    goCdkPopoverTrigger="click"
                    goCdkPopoverMaxHeight="calc(100vh - 32px)">
                  </button>
                </div>
              </th>
              @if (showPlanColumn$ | async) {
                <th class="license-plan-cell" translate="license-management_plan"></th>
              }
              <th class="action-cell" [attr.aria-label]="'common_actions' | translate"></th>
            </tr>
          </thead>
          <tbody>
            @for (salesforceLicense of licenses; track salesforceLicense) {
              <tr class="license-row" [ngClass]="{'expanded': expandedLicenses[salesforceLicense.id]}">
                <td class="license-name">
                  <span>
                    @if (canExpandLicenseHolders(salesforceLicense)) {
                      <button
                        [attr.aria-label]="'license-management_expand-row' | translate"
                        class="expand-button icon-btn ficon-app-chevron-down"
                        [class.rotated]="expandedLicenses[salesforceLicense.id]"
                        [disabled]="disableLicenseHolderToggle(salesforceLicense)"
                        (click)="toggleLicenseHolders(salesforceLicense)"
                      ></button>
                    } @else {
                      <span class="expand-button icon-btn ficon-app-chevron-down expand-button-placeholder" aria-hidden="true"></span>
                    }
                    {{salesforceLicense.name}} -
                    <span class="seat-type">{{(salesforceLicense.seat_type === 'user' ? 'license-management_multi-course' : 'license-management_single-course') | translate}}</span>
                  </span>
                </td>
                <td>{{ salesforceLicense.license.current_access_date | date: 'mediumDate' }}</td>
                <td>
                  <div class="license-end-date">
                    <span>{{ salesforceLicense.license.ends_at | date: 'mediumDate' }}</span>
                    <ng-template #tooltipTemplate>
                      {{ salesforceLicense.dotIcon.expirationDot.toolTip.key | translate: getExpirationTooltipTranslationParams(salesforceLicense) }}
                      @if (showRenewLicenseButton(salesforceLicense)) {
                        <p>
                          <button
                            class="goreact-btn secondary-btn"
                            (click)="renewLicense(salesforceLicense)"
                            [translate]="salesforceLicense.is_free_trial ? 'license-management_create-licenses': 'license-management_renew-license'">
                          </button>
                        </p>
                      }
                    </ng-template>
                    @if (showLicenseEndDateDot(salesforceLicense)) {
                      <div class="license-dot"
                        tabindex="0"
                        [ngClass]="salesforceLicense.dotIcon.expirationDot.color"
                      [goCdkPopover]="tooltipTemplate"></div>
                    }
                  </div>
                </td>
                <td>
                  <div class="seats-usage">
                    @if (showLicenseMenu(salesforceLicense)) {
                      <button class="goreact-btn link-btn seats-used-lnk"
                        type="button"
                        aria-labelledby="seats-used-column"
                        (click)="navigateToLicenseSeatsManagement(salesforceLicense.license_id)">
                        {{ salesforceLicense.total_seats_consumed }}
                        @if (salesforceLicense.seat_overage_policy === SeatOveragePolicies.RESTRICTED) {
                          <span>
                            / {{salesforceLicense.total_seats}}
                          </span>
                        }
                      </button>
                    }
                    @if (!showLicenseMenu(salesforceLicense)) {
                      <div>
                        {{ salesforceLicense.total_seats_consumed }}
                        @if (salesforceLicense.seat_overage_policy === SeatOveragePolicies.RESTRICTED) {
                          <span>
                            / {{salesforceLicense.total_seats}}
                          </span>
                        }
                      </div>
                    }
                    @if (salesforceLicense.seat_overage_policy === SeatOveragePolicies.RESTRICTED) {
                      <div class="license-dot"
                        tabindex="0"
                        [ngClass]="salesforceLicense.dotIcon.usageDot.color"
                      [goCdkPopover]="salesforceLicense.dotIcon.usageDot.toolTip.key | translate: {usagePercent: salesforceLicense.dotIcon.usageDot.toolTip.value, seatCount: salesforceLicense.dotIcon.usageDot.toolTip.seatCount}"></div>
                    }
                  </div>
                </td>
                @if (showPlanColumn$ | async) {
                  <td class="license-plan-cell">
                    <license-plan-badge
                      [license]="salesforceLicense.license"
                      [disabled]="licenseBadgesDisabled$ | async"
                      (actionClick)="onLicensePlanBadgeClicked(salesforceLicense)"
                      [hideAction]="hideLicensePlanBadgeActionButton(salesforceLicense)"
                      [shouldRenew]="shouldShowRenewButtonInBadge(salesforceLicense)"
                      >
                    </license-plan-badge>
                  </td>
                }
                @if (showLicenseMenu(salesforceLicense)) {
                  <td class="license-action-btns-container">
                    <div class="license-action-btns">
                      @if (showPurchaseSeatsButton(salesforceLicense)) {
                        <button
                          type="button"
                          (click)="purchaseSeats(salesforceLicense)"
                          class="primary-btn inline-seats-btn"
                          >
                          <span translate="license-management_purchase-add-seats"></span>
                        </button>
                      }
                      <button
                        type="button"
                        class="action-menu-btn icon-btn ficon-app-dots-vertical"
                        [matMenuTriggerFor]="actionsMenu"
                        [attr.aria-label]="'license-management_purchase-more-seats' | translate">
                      </button>
                      <mat-menu #actionsMenu class="action-menu">
                        <button
                          mat-menu-item
                          (click)="navigateToLicenseSeatsManagement(salesforceLicense.license_id)"
                          class="view-all-seats-btn">
                          <span translate="license-management_view-all-seats"></span>
                        </button>
                        @if (showPurchaseSeatsButton(salesforceLicense)) {
                          <button
                            mat-menu-item
                            (click)="purchaseSeats(salesforceLicense)"
                            class="additional-seats-btn"
                            >
                            <span translate="license-management_purchase-more-seats"></span>
                          </button>
                        }
                        @if (showRenewLicenseMenuButton(salesforceLicense)) {
                          <button
                            mat-menu-item
                            (click)="renewLicense(salesforceLicense)"
                            class="renew-btn"
                            >
                            <span [translate]="salesforceLicense.is_free_trial ? 'license-management_create-licenses': 'license-management_renew-license'"></span>
                          </button>
                        }
                      </mat-menu>
                    </div>
                  </td>
                }
              </tr>
              @if (expandedLicenses[salesforceLicense.id]) {
                <tr class="instructors-row">
                  <td colspan="6" class="license-holder-content">
                    <license-holder
                      [salesforceLicense]="salesforceLicense"
                      (loadFailed)="handleLicenseHoldersLoadFailed(salesforceLicense)"
                    (viewSeatsEvent)="navigateToLicenseSeatsManagement(salesforceLicense.license_id, $event)"></license-holder>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    } @else {
      <ngx-zero-state>
        <p zero-state-title>{{'license-management_zero-title' | translate}}</p>
        <p zero-state-subtext>{{'license-management_zero-subtitle' | translate }}</p>
        <div zero-state-body>
          <button class="primary-btn" (click)="createLicense(true)">{{'license-management_create-licenses' | translate}}</button>
          <img class="middle-image" [src]="activeBrandService.getImage('floating-astronaut.svg')" alt="No Results">
        </div>
      </ngx-zero-state>
    }
    @if (showCreateLicenseButton && licenses.length) {
      <div class="add-license-btn-wrapper">
        <button class="link-btn request-invoice-btn" (click)="createLicense(false)">
          {{'payment-panel-footer-switch-mode-invoice-label' | translate}}
        </button>
        <button class="secondary-btn add-license-btn" (click)="createLicense(true)">
          {{'license-management_create-licenses' | translate}}
        </button>
      </div>
    }
  </div>
} @else {
  <img [src]="spotLogo.src" class="loading" [alt]="spotLogo.alt" />
}
